/**
 * Get table headers for viewer or admin.
 *
 * @returns array of table headers.
 */
export const getHeaders = (): string[] => {
  const headers = [
    'Company',
    'Country',
    'Industry',
    'Group',
    'Initial Inv. Date',
    'Investment',
    'Fair value',
    'Gain/Loss',
    'Holding %',
    'MOIC',
    'IRR',
    'Total Raised',
    'Valuation',
    'Company ID',
    'Investment account (Assets)',
    'Unrealized account (Assets)',
    'Interest account (Assets)',
    'Unrealized account (P&L)',
    'Realized account (P&L)',
    'Interest account (P&L)',
    'Last round name',
    'Last round date',
    'Current company value',
  ];
  return headers;
};

export const getFilteredHeaders = (): string[] => {
  const regularHeaders = (getMapHeaders());
  const filteredHeaders = ['Company'].concat(Object.values(regularHeaders));
  return filteredHeaders;
};

export const getMapHeaders = (): any => {
  const headers = {
    country: 'Country',
    industry: 'Industry',
    companyGroup: 'Group',
    initialDate: 'Initial Inv. Date',
    cost: 'Investment',
    fairValue: 'Fair value',
    gainLoss: 'Gain/Loss',
    holding: 'Holding %',
    multiple: 'MOIC',
    irr: 'IRR',
    raised: 'Total Raised',
    valuation: 'Valuation',
    valuationRoundName: 'Last round name',
    valuationRoundDate: 'Last round date',
    totalCommitment: 'Total commitment',
    unfundedCommitment: 'Unfunded commitment',
  };
  return headers;
};

